import { usePreparationCountWorkspace } from "./usePreparationCountWorkspace";
export function PhysicalCountActionsView({ item, workspace }: { item: Parameters<typeof usePreparationCountWorkspace>[0]["item"]; workspace: ReturnType<typeof usePreparationCountWorkspace> }) {
  const { scopes, values, setValues, saving, save, scopeLabel } = workspace;
  if (!scopes.length) return null;
  return (
    <div className="preparation-count-actions">
      {scopes.map((scope) => (
        <label key={scope}>
          <span>{scopeLabel(scope)} fiziki sayımı</span>
          <span>
            <input
              type="number"
              min="0"
              step="any"
              value={values[scope] ?? ""}
              onChange={(event) =>
                setValues((current) => ({
                  ...current,
                  [scope]: event.target.value,
                }))
              }
              aria-label={`${item.materialCode} ${scopeLabel(scope).toLocaleLowerCase("tr-TR")} fiziki miktarı`}
            />
            <b>{item.unit}</b>
            <button
              type="button"
              disabled={saving || values[scope] == null || values[scope] === ""}
              onClick={() => void save(scope)}
            >
              {saving ? "Kaydediliyor…" : "Teyit et"}
            </button>
          </span>
        </label>
      ))}
    </div>
  );
}

export function PhysicalCountActions(props: Parameters<typeof usePreparationCountWorkspace>[0]) {
  const workspace = usePreparationCountWorkspace(props);
  return <PhysicalCountActionsView item={props.item} workspace={workspace} />;
}
